import React, { useState, useEffect } from 'react';
import './Footer.scss';
import axios from 'axios';

export const Footer = () => {
  const [footer, setFooter] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_LEGACY_BASE_HOST}/Utility/Footer`)
      .then((response) => {
        setFooter(response.data);
      });
  }, []);
  return (
    <footer id="footer" className="ph-footer footer-container" dangerouslySetInnerHTML={{ __html: footer }}>
    </footer>
  );
};
